// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"451":"ed1c4671fc6ea963","480":"182411aefcc026b1","585":"c15024d963661843"}[chunkId] + ".js";
};